import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionLCSLHPTIFields } from '../types/fields';
import { OperacionLCSLHPTI } from "../types/types";

type SeccionLCSLHPTIDatosOperacionProps = {
  operacion?: OperacionLCSLHPTI;
}

const SeccionLCSLHPTIDatosOperacion = ({ operacion }: SeccionLCSLHPTIDatosOperacionProps) => {
  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      {operacion && (
        <SectionBox>
          <Grid item xs={12} md={2}>
            <FieldView label='País' value={operacion[OperacionLCSLHPTIFields.NombrePais]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Usuario Alta'
              value={`${operacion[OperacionLCSLHPTIFields.NombreUsuarioAlta]} ${operacion[OperacionLCSLHPTIFields.ApellidoUsuarioAlta]}`}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView label='Unidad de Negocio' value={operacion[OperacionLCSLHPTIFields.DescUnidadNegocio]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView label='Equipo Comercial' value={operacion[OperacionLCSLHPTIFields.DescSectorComercial]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Fecha de Solicitud'
              value={operacion[OperacionLCSLHPTIFields.FechaSolicitud]
                ? dateFormatter.toShortDate(operacion[OperacionLCSLHPTIFields.FechaSolicitud])
                : undefined}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Fecha de Vencimiento'
              value={operacion[OperacionLCSLHPTIFields.FechaVencimiento]
                ? dateFormatter.toShortDate(operacion[OperacionLCSLHPTIFields.FechaVencimiento])
                : undefined}
            />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones' value={operacion[OperacionLCSLHPTIFields.Observaciones]} />
          </Grid>
        </SectionBox>
      )}
    </CardActions>
  );
}

export default SeccionLCSLHPTIDatosOperacion;